import debug from 'debug'

export default debug('danone:apollo-client')
